import { Fun, Pair, mk_widget, Option, none, some } from 'widgets-for-react'
import { List } from 'immutable'
import React from 'react'
import { Breadcrumb } from '../../wordpress/types_and_parser/extra_types.mod'
import { ParsedNode } from '../../wordpress/types_and_parser/types.ext.gen'
import { ContentType } from '../../public_site.main.mod'
import { Link } from 'react-router-dom'
import { decodeHTMLEntities, toRelativeUrl } from '../../../helpers'
import { WordPress } from '../../wordpress/wordpress_api'
import { visit_option } from '../../../utils'

export const page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType> = (page) => (blocks) => {
  const maybe_references = page.snd.v.kind == 'r' && (page.snd.v.v.type == 'article' || page.snd.v.v.type == 'news') && page.snd.v.v.acf && page.snd.v.v.acf.reference ? some(page.snd.v.v.acf.reference) : none<string>()

  return mk_widget({
    run: (o) => (
      <>
        <main className="main">
          <div className="main__inner">
            <article className={`page page--${page.snd.v.kind == 'r' && page.snd.v.v.type}${page.snd.v.kind == 'r' && page.snd.v.v.is_front ? ' page--home' : ''}`}>
              <div className="page__inner">
                <div className="page__content">
                  {page.snd.v.kind == 'r' &&
                    page.snd.v.v.breadcrumb &&
                    page.snd.v.v.breadcrumb.itemListElement.length > 0 && (
                      <nav className="breadcrumbs">
                        <div className="breadcrumbs__inner container container--m gutter--m">
                          <ul className="breadcrumbs__list">
                            <li className="breadcrumbs__item">
                              <Link to={toRelativeUrl('/')} className="breadcrumbs__link typo--s ff--secondary fw--light">
                                <span>Home</span>
                                <svg className="breadcrumbs__icon" height="6" width="9" aria-hidden="true"><use xlinkHref="#chevron--down" /></svg>
                              </Link>
                            </li>
                            {page.snd.v.v.breadcrumb.itemListElement.map((item) =>
                              item.item['@id'] ? (
                                <li className="breadcrumbs__item">
                                  <Link to={toRelativeUrl(item.item['@id'])} className="breadcrumbs__link typo--s ff--secondary fw--light">
                                    <span>{decodeHTMLEntities(item.item.name)}</span>
                                    <svg className="breadcrumbs__icon" height="6" width="9" aria-hidden="true"><use xlinkHref="#chevron--down" /></svg>
                                  </Link>
                                </li>
                              ) : (
                                <li className="breadcrumbs__item">
                                  <span className="breadcrumbs__link typo--s ff--secondary fw--light">{decodeHTMLEntities(item.item.name)}</span>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </nav>
                    )}
                  {blocks.run(o)}
                  {visit_option(maybe_references)(reference => <aside className='page__sidebar sidebar sdb'>
                    <div className="sdb__inner container container--s gutter--m spacing--m text--styled" dangerouslySetInnerHTML={{ __html: reference }} />
                  </aside>,
                    () => <></>
                  )}
                </div>
              </div>
            </article>
          </div>
        </main>
      </>
    ),
  })
}
